import(/* webpackMode: "eager" */ "/app/src/app/home/[lang]/error.tsx")